// extracted by mini-css-extract-plugin
module.exports = {"container":"MaxWidth_container__i2u3j","small":"MaxWidth_small__PmRBc","large":"MaxWidth_large__MWgis","extraLarge":"MaxWidth_extraLarge__HIr4C"};